import axios from "axios";
import { AUTH_TOKEN_KEY } from "../../constants/localstorageKeys";
import routes from "../../configs/api";

const approvePendingUser = async (userId) => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  const URL = `${routes.APPROVE_PENDING_USER}/${userId}`;

  console.log("Toggling Vendor API:", URL);

  return new Promise((resolve, reject) => {
    axios
      .patch(
        URL,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default approvePendingUser;
